// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.availability-page .availability-loading {
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #74788d;
}
.availability-page .availability-card {
  border: 0;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(18, 38, 63, 0.08);
  margin-bottom: 24px;
}
.availability-page .availability-card__heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding-bottom: 18px;
  margin-bottom: 20px;
  border-bottom: 1px solid #eff2f7;
}
.availability-page .availability-card__heading h5 {
  margin-bottom: 5px;
}
.availability-page .availability-card__heading p {
  color: #74788d;
  margin: 0;
}
.availability-page .availability-field-group h6 {
  color: #495057;
  margin-bottom: 14px;
}
.availability-page .duration-input {
  max-width: 280px;
}
.availability-page .availability-list {
  display: grid;
  gap: 12px;
}
.availability-page .availability-list__item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 16px 18px;
  border: 1px solid #e7eaf0;
  border-radius: 10px;
  background: #fff;
}
.availability-page .availability-list__item strong {
  display: block;
  margin-bottom: 4px;
  color: #343a40;
}
.availability-page .availability-list__item small {
  color: #74788d;
}
.availability-page .availability-list__item--compact strong {
  margin-bottom: 0;
}
.availability-page .availability-list__actions {
  display: flex;
  align-items: center;
}
.availability-page .availability-empty {
  text-align: center;
  color: #74788d;
  background: #f8f9fa;
  border-radius: 10px;
  padding: 26px;
  margin: 0;
}
@media (max-width: 575.98px) {
  .availability-page .availability-card__heading,
  .availability-page .availability-list__item {
    align-items: stretch;
    flex-direction: column;
  }
  .availability-page .availability-card__heading .btn {
    width: 100%;
  }
  .availability-page .availability-list__actions {
    justify-content: flex-end;
  }
}

.availability-profile-section {
  margin-top: 8px;
  margin-bottom: 24px;
  padding: 22px;
  border: 1px solid #e7eaf0;
  border-radius: 10px;
  background: #fdfdfd;
}
.availability-profile-section h6 {
  color: #495057;
  margin-bottom: 14px;
}
.availability-profile-section .duration-input {
  max-width: 280px;
}
.availability-profile-section .availability-inline-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 80px;
  color: #74788d;
}`, "",{"version":3,"sources":["webpack://./src/pages/Administration/components/Availability.scss"],"names":[],"mappings":"AACE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,cAAA;AAAJ;AAGE;EACE,SAAA;EACA,mBAAA;EACA,6CAAA;EACA,mBAAA;AADJ;AAIE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,oBAAA;EACA,mBAAA;EACA,gCAAA;AAFJ;AAII;EACE,kBAAA;AAFN;AAII;EACE,cAAA;EACA,SAAA;AAFN;AAME;EACE,cAAA;EACA,mBAAA;AAJJ;AAOE;EACE,gBAAA;AALJ;AAOE;EACE,aAAA;EACA,SAAA;AALJ;AAQE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AANJ;AAQI;EACE,cAAA;EACA,kBAAA;EACA,cAAA;AANN;AAQI;EACE,cAAA;AANN;AAUE;EACE,gBAAA;AARJ;AAUE;EACE,aAAA;EACA,mBAAA;AARJ;AAWE;EACE,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;AATJ;AAYE;EACE;;IAEE,oBAAA;IACA,sBAAA;EAVJ;EAYE;IACE,WAAA;EAVJ;EAYE;IACE,yBAAA;EAVJ;AACF;;AAcA;EACE,eAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;AAXF;AAaE;EACE,cAAA;EACA,mBAAA;AAXJ;AAcE;EACE,gBAAA;AAZJ;AAeE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,cAAA;AAbJ","sourcesContent":[".availability-page {\n  .availability-loading {\n    min-height: 240px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    color: #74788d;\n  }\n\n  .availability-card {\n    border: 0;\n    border-radius: 12px;\n    box-shadow: 0 2px 10px rgba(18, 38, 63, 0.08);\n    margin-bottom: 24px;\n  }\n\n  .availability-card__heading {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    gap: 16px;\n    padding-bottom: 18px;\n    margin-bottom: 20px;\n    border-bottom: 1px solid #eff2f7;\n\n    h5 {\n      margin-bottom: 5px;\n    }\n    p {\n      color: #74788d;\n      margin: 0;\n    }\n  }\n\n  .availability-field-group h6 {\n    color: #495057;\n    margin-bottom: 14px;\n  }\n\n  .duration-input {\n    max-width: 280px;\n  }\n  .availability-list {\n    display: grid;\n    gap: 12px;\n  }\n\n  .availability-list__item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 20px;\n    padding: 16px 18px;\n    border: 1px solid #e7eaf0;\n    border-radius: 10px;\n    background: #fff;\n\n    strong {\n      display: block;\n      margin-bottom: 4px;\n      color: #343a40;\n    }\n    small {\n      color: #74788d;\n    }\n  }\n\n  .availability-list__item--compact strong {\n    margin-bottom: 0;\n  }\n  .availability-list__actions {\n    display: flex;\n    align-items: center;\n  }\n\n  .availability-empty {\n    text-align: center;\n    color: #74788d;\n    background: #f8f9fa;\n    border-radius: 10px;\n    padding: 26px;\n    margin: 0;\n  }\n\n  @media (max-width: 575.98px) {\n    .availability-card__heading,\n    .availability-list__item {\n      align-items: stretch;\n      flex-direction: column;\n    }\n    .availability-card__heading .btn {\n      width: 100%;\n    }\n    .availability-list__actions {\n      justify-content: flex-end;\n    }\n  }\n}\n\n.availability-profile-section {\n  margin-top: 8px;\n  margin-bottom: 24px;\n  padding: 22px;\n  border: 1px solid #e7eaf0;\n  border-radius: 10px;\n  background: #fdfdfd;\n\n  h6 {\n    color: #495057;\n    margin-bottom: 14px;\n  }\n\n  .duration-input {\n    max-width: 280px;\n  }\n\n  .availability-inline-loading {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    min-height: 80px;\n    color: #74788d;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
